import { TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, SIZES } from '@constants/fonts.ts';
import { BODY_SM_SM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const AuthSharedWrapper = styled.div`
    min-height: 100%;
    box-sizing: border-box;
    padding: clamp(32px, 5vh, 96px) 80px clamp(24px, 4vh, 64px);
    display: flex;
    flex-direction: column;
`;

export const FormSection = styled.div<{ $maxWidth?: number }>`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    max-width: ${({ $maxWidth = 400 }) => `${$maxWidth}px`};
    align-self: center;
`;

export const FooterLogoSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-shrink: 0;
`;

export const PasswordSection = styled.div`
    display: flex;
    align-self: end;
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize}
    cursor: pointer;
    ${DESKTOP_SIZES[SIZES.BODY_XL_MED].fontWeight}
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight}
    color: ${TC.action};
`;

export const AlertSection = styled.div`
    margin: 20px 0;
`;

export const SuccessMessageSection = styled.div`
    margin-bottom: 0;

    h1 {
        margin: 0;
        text-align: center;
    }
`;

export const InvalidEmailErrorMsg = styled.div`
    ${BODY_SM_SM_STYLES};
    color: ${TC.error};
    text-align: right;
`;
